module.exports = __webpack_public_path__ + "img/grey-color.98cbc42c.jpg";